import { Component } from 'react';

class OvertAggressionScale extends Component {
  render() {
    return <h1>Overt Aggression Scale</h1>;
  }
}

export default OvertAggressionScale;
